<template>
    <div>
<!--        Login form updated by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.loginFormUpdated', {user:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "LoginFormUpdated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
